import NftEventsEmpty from './NftEventsEmpty';

export default NftEventsEmpty;
